export var ServiceType;
(function (ServiceType) {
    ServiceType["REGULAR"] = "REGULAR";
    ServiceType["PACKAGE"] = "PACKAGE";
})(ServiceType || (ServiceType = {}));
